export const translations = {
	'Rule successfully deleted': {
		no: 'Reglen er slettet',
	},
	'Create KPI': {
		no: 'Opprett',
	},
	'Are you sure you want to remove KPI?': {
		no: 'Er du sikker på at du vil slette KPI profilen',
	},
	'KPI successfully deleted': {
		no: 'KPI profilen er slettet',
	},
	'Kpi accounts': {
		no: 'Kpi kontoer',
	},
	'Select category': {
		no: 'Velg rolle',
	},
	'Select rule type': {
		no: 'Velg regeltype',
	},
	'Select samplerate': {
		no: 'Velg samplingsrate',
	},
	'Select kpi Accounts': {
		no: 'Velg kontoer (KPI)',
	},
	'Display rate': {
		no: 'Visning',
	},
	'Kpi metrics': {
		no: 'Kpi metrikker',
	},
	'No accounts': {
		no: 'Ingen kontoer er opprettet',
	},
};
